"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authSuccess = exports.authSSO = exports.authResetCrm = exports.authReset = exports.authRefreshToken = exports.authProfile = exports.authLogout = exports.authLogin = exports.authGetUserLatestDetail = exports.authError = exports.authCrmRedirect = exports.authCrmDetail = void 0;
var _auth = require("./auth.constant");
// @flow

// common success
var authSuccess = function authSuccess(actionType, data) {
  return {
    type: _auth.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.authSuccess = authSuccess;
var authError = function authError(actionType, error) {
  return {
    type: _auth.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
exports.authError = authError;
var authLogin = function authLogin(data) {
  return {
    type: _auth.actionTypes.LOGIN,
    payload: data
  };
};

/*
 * logged in user details
 * @param payload
 * @returns api response
 * @description this function used to get logged in user's details.
 */
exports.authLogin = authLogin;
var authProfile = function authProfile() {
  return {
    type: _auth.actionTypes.DETAILS
  };
};

/**
 * Refresh Token
 * @param payload
 * @returns api response
 * @description this function used to refresh the existing access token.
 */
exports.authProfile = authProfile;
var authRefreshToken = function authRefreshToken(data) {
  return {
    type: _auth.actionTypes.REFRESH_TOKEN,
    payload: data
  };
};

/**
 * Logout
 * @returns api response
 * @description this function used to user logout.
 */
exports.authRefreshToken = authRefreshToken;
var authLogout = function authLogout() {
  return {
    type: _auth.actionTypes.LOGOUT
  };
};

/**
 * Reset auth
 * @param payload
 * @returns api response
 * @description this function used to reset auth.
 */
exports.authLogout = authLogout;
var authReset = function authReset() {
  return {
    type: _auth.actionTypes.RESET
  };
};

/**
 * SSO auth
 * @param payload
 * @returns api response
 * @description this function used to authenticate sso login.
 */
exports.authReset = authReset;
var authSSO = function authSSO(data) {
  return {
    type: _auth.actionTypes.SSO,
    payload: data
  };
};

/**
 * SSO auth
 * @param payload
 * @returns api response
 * @description this function used to authenticate sso login.
 */
exports.authSSO = authSSO;
var authGetUserLatestDetail = function authGetUserLatestDetail(data) {
  return {
    type: _auth.actionTypes.USER_LATEST_DETAIL,
    payload: data
  };
};

/**
 * crm
 * @param payload
 * @returns api response
 * @description this function used to get crm.
 */
exports.authGetUserLatestDetail = authGetUserLatestDetail;
var authCrmDetail = function authCrmDetail(data) {
  return {
    type: _auth.actionTypes.CRM_DETAIL,
    payload: data
  };
};

/**
 * crm redirect
 * @param payload
 * @returns api response
 * @description this function used to crm redirect.
 */
exports.authCrmDetail = authCrmDetail;
var authCrmRedirect = function authCrmRedirect(data) {
  return {
    type: _auth.actionTypes.CRM_REDIRECT,
    payload: data
  };
};

/**
 * Reset auth
 * @param payload
 * @returns api response
 * @description this function used to reset auth.
 */
exports.authCrmRedirect = authCrmRedirect;
var authResetCrm = function authResetCrm() {
  return {
    type: _auth.actionTypes.RESET_CRM
  };
};
exports.authResetCrm = authResetCrm;